/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_DisclaimerInputs */

const en_us2_profile_editors_pain_disclaimer = /** @type {(inputs: Profile_Editors_Pain_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app adapts training, it does not treat injuries. If the pain is strong, gets worse or does not go away, see a health professional.`)
};

const pt_br2_profile_editors_pain_disclaimer = /** @type {(inputs: Profile_Editors_Pain_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O app adapta o treino, não trata lesões. Se a dor for forte, piorar ou não passar, procure um profissional de saúde.`)
};

const es_419_profile_editors_pain_disclaimer = /** @type {(inputs: Profile_Editors_Pain_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La app adapta el entrenamiento, no trata lesiones. Si el dolor es fuerte, empeora o no se va, consulta a un profesional de la salud.`)
};

const pt_pt2_profile_editors_pain_disclaimer = /** @type {(inputs: Profile_Editors_Pain_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A app adapta o treino, não trata lesões. Se a dor for forte, piorar ou não passar, procura um profissional de saúde.`)
};

const fr_fr2_profile_editors_pain_disclaimer = /** @type {(inputs: Profile_Editors_Pain_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'app adapte l'entraînement, elle ne soigne pas les blessures. Si la douleur est forte, empire ou ne passe pas, consulte un professionnel de santé.`)
};

const de_de2_profile_editors_pain_disclaimer = /** @type {(inputs: Profile_Editors_Pain_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die App passt das Training an, sie behandelt keine Verletzungen. Wenn der Schmerz stark ist, schlimmer wird oder nicht weggeht, geh zu einer Fachperson.`)
};

const it_it2_profile_editors_pain_disclaimer = /** @type {(inputs: Profile_Editors_Pain_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'app adatta l'allenamento, non cura gli infortuni. Se il dolore è forte, peggiora o non passa, rivolgiti a un professionista sanitario.`)
};

/**
* | output |
* | --- |
* | "The app adapts training, it does not treat injuries. If the pain is strong, gets worse or does not go away, see a health professional." |
*
* @param {Profile_Editors_Pain_DisclaimerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_disclaimer = /** @type {((inputs?: Profile_Editors_Pain_DisclaimerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_DisclaimerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_disclaimer(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_disclaimer(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_disclaimer(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_disclaimer(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_disclaimer(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_disclaimer(inputs)
	return en_us2_profile_editors_pain_disclaimer(inputs)
});
export { profile_editors_pain_disclaimer as "profile-editors.pain_disclaimer" }